import { render, staticRenderFns } from "./StudentUnion.vue?vue&type=template&id=289f0d2b&"
import script from "./StudentUnion.vue?vue&type=script&lang=js&"
export * from "./StudentUnion.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports